import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('deptMngPopupStore', Object.keys(getters)),
	...mapState('deptMngPopupStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('deptMngPopupStore', Object.keys(actions)),
	...mapMutations('deptMngPopupStore', Object.keys(mutations))
};
